import type { PrintTemplateDSL } from 'print-template-component';

/** 首期演示模板，后续由 gateway / print-service 下发 */
export const DEMO_RECEIPT_TEMPLATE: PrintTemplateDSL = {
  version: '1.0',
  paperWidth: 80,
  pagePadding: [8, 8, 8, 8],
  cutMode: 'AT_CURRENT',
  components: [
    {
      id: 'demo-title',
      type: 'text',
      label: '门店名称',
      config: {
        value: '{{shop.name}}',
        bind: 'shop.name',
        style: { align: 'center', bold: true, fontSize: 18 },
      },
    },
    {
      id: 'demo-divider',
      type: 'divider',
      label: '分隔线',
      config: {
        style: 'solid',
      },
    },
    {
      id: 'demo-order',
      type: 'text',
      label: '订单号',
      config: {
        value: '{{order.no}}',
        bind: 'order.no',
        style: { align: 'left', fontSize: 14 },
      },
    },
  ],
};

export const DEMO_PREVIEW_DATA: Record<string, unknown> = {
  shop: { name: '示例门店' },
  order: { no: 'A20260805001' },
};
